import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.string.replace-all.js";
import "core-js/modules/esnext.json.parse.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import HuashuEdit from "./HuashuEdit";
export default {
  props: [],
  data() {
    return {
      list: [],
      huashuEditShow: false,
      currentItem: null,
      page: 1,
      pageSize: 20,
      typeList: []
    };
  },
  components: {
    HuashuEdit
  },
  methods: {
    huashuEditClose() {
      this.huashuEditShow = false;
    },
    huashuEditSuccess() {
      this.$message({
        message: "提交成功",
        type: "success"
      });
      setTimeout(() => {
        this.huashuEditShow = false;
        window.location.reload();
      }, 1000);
    },
    async refuseClick(idx) {
      this.$prompt("", "拒绝原因", {
        confirmButtonText: "保存",
        cancelButtonText: "取消",
        inputPattern: /^.+$/,
        inputErrorMessage: "拒绝原因不能为空"
      }).then(async ({
        value
      }) => {
        this.currentItem = this.list[idx];
        this.currentItem.refuseReason = value;
        await this.huashuCheck(1);
        this.$message({
          message: "提交成功",
          type: "success"
        });
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }).catch(() => {});
    },
    async agreeClick(idx) {
      this.currentItem = this.list[idx];
      await this.huashuCheck(0);
      this.$message({
        message: "提交成功",
        type: "success"
      });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },
    async huashuCheck(isRefuse) {
      return new Promise(async (resolve, reject) => {
        let params = {
          speechId: this.currentItem.speechId,
          checkId: this.currentItem.checkId,
          isRefuse: isRefuse
        };
        if (isRefuse) {
          params.refuseReason = this.currentItem.refuseReason;
        }
        let resp = await this.$http.huashuReviewCheck(params);
        if (resp.code == 200) {
          resolve();
        }
      });
    },
    modifyClick(idx) {
      this.currentItem = this.list[idx];
      localStorage.setItem("editHuashuData", JSON.stringify(this.currentItem));
      this.huashuEditShow = true;
    },
    backClick() {
      this.$router.go(-1);
    },
    // 提取文件后缀的辅助函数
    getFileExtension(url) {
      const path = url.split("/");
      const fileName = path[path.length - 1];
      const parts = fileName.split(".");
      if (parts.length > 1) {
        return parts.pop();
      }
      return "";
    },
    replaceAll(string, search, replace) {
      return string.split(search).join(replace);
    },
    getFileIcon(fileName) {
      let icon = "";
      if (fileName.includes(".doc")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143256.png";
      } else if (fileName.includes(".txt")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143245.png";
      } else if (fileName.includes(".xls")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230602143214.png";
      } else if (fileName.includes(".mp3") || fileName.includes(".m4a")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114041.png";
      } else if (fileName.includes(".pdf")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230529114100.png";
      } else if (fileName.includes(".ppt") || fileName.includes(".pptx")) {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230608114321.png";
      } else {
        icon = "https://imagessl.edujia.com/A-1ed71af7_20230601152642.png";
      }
      return icon;
    },
    //type: img、video、file
    getContentEditorFileItem(path, type, file) {
      const fileElement = document.createElement("div");
      fileElement.setAttribute("id", path);
      fileElement.setAttribute("contenteditable", "false");
      if (type == "img") {
        // fileElement.setAttribute('style', `background-image: url(${path})`);
        // fileElement.setAttribute('class', 'contentImgItem');
        const imgEle = document.createElement("img");
        imgEle.setAttribute("class", "contentImgItemImg");
        imgEle.setAttribute("src", path);
        fileElement.setAttribute("class", "contentImgItem");
        fileElement.appendChild(imgEle);
      } else if (type == "video") {
        const videoEle = document.createElement("video");
        videoEle.setAttribute("src", path);
        fileElement.setAttribute("class", "contentVideoItem");
        fileElement.appendChild(videoEle);
        const videoIconEle = document.createElement("img");
        videoIconEle.setAttribute("src", "https://imagessl.edujia.com/A-1ed71af7_20231013134229.png");
        videoIconEle.setAttribute("class", "contentVideoItemIcon");
        fileElement.appendChild(videoIconEle);
      } else if (type == "videoPreview") {
        fileElement.setAttribute("style", `background-image: url(${path})`);
        fileElement.setAttribute("class", "contentVideoPrviewItem");
      } else if (type == "file") {
        const fileoEle = document.createElement("div");
        fileElement.appendChild(fileoEle);
        const iconEle = document.createElement("img");
        iconEle.src = this.getFileIcon(file.file.name);
        iconEle.setAttribute("class", "contentFileItemIcon");
        fileElement.appendChild(iconEle);
        const nameEle = document.createElement("div");
        nameEle.innerHTML = file.file.name;
        nameEle.setAttribute("class", "contentFileItemLabel");
        fileElement.appendChild(nameEle);
        fileElement.setAttribute("class", "contentFileItem");
      }
      return fileElement;
    },
    async qryHuashuList() {
      return new Promise(async (resolve, reject) => {
        let params = {
          page: this.page,
          pageSize: this.pageSize,
          speechId: localStorage.getItem("lastSelSpeechId"),
          status: 0 //状态：0待审核，1拒绝，默认0
        };
        let resp = await this.$http.huashuReview(params);
        if (resp.code == 200) {
          let list = resp.data.array.map(val => {
            let typeResult = this.typeList.find(type => {
              return type.labelId == val.labelId;
            });
            if (typeResult) {
              val.labelName = typeResult.labelName;
            }
            let eleList = [];
            let text = val.speechText;
            text = this.replaceAll(text, "<分段>", "");
            text = this.replaceAll(text, "\n", "<br>");
            text = this.replaceAll(text, "\\n", "<br>");
            const urlRegex = /https?:\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]\.(png|jpg|jpeg|pdf|docx|doc|dotm|xlsx|xls|mp4|mov|mp3|m4a|aac|caf|pptx|ppt|txt)/gi;
            let match;
            let lastPart = text;
            let newText = "";
            while ((match = urlRegex.exec(text)) !== null) {
              let url = match[0];
              const fileExtension = this.getFileExtension(url);

              // 只添加具有正确文件后缀的URL
              if (fileExtension === "png" || fileExtension === "jpg" || fileExtension === "jpeg" || fileExtension === "pdf" || fileExtension === "doc" || fileExtension === "docx" || fileExtension === "dotm" || fileExtension === "dotx" || fileExtension === "dotm" || fileExtension === "txt" || fileExtension === "xlsx" || fileExtension === "xls" || fileExtension === "mp4" || fileExtension === "mov" || fileExtension === "mp3" || fileExtension === "m4a" || fileExtension === "aac" || fileExtension === "caf" || fileExtension === "ppt" || fileExtension === "pptx") {
                let tmp = lastPart.split(url);
                // console.log("tmp==",tmp[0]);
                if (fileExtension === "jpg" || fileExtension === "png" || fileExtension === "jpeg") {
                  let fileElement = this.getContentEditorFileItem(url, "img");
                  newText += tmp[0] + fileElement.outerHTML;
                  lastPart = tmp[1];
                } else if (fileExtension === "mp4") {
                  eleList.push({
                    type: "video",
                    val: url
                  });
                } else if (fileExtension === "mp3" || fileExtension === "m4a") {
                  let tmpUrl = new URL(url);
                  let fileName = tmpUrl.pathname.split("/").pop();
                  let fileElement = this.getContentEditorFileItem(url, "file", {
                    file: {
                      name: fileName
                    }
                  });
                  newText += tmp[0] + fileElement.outerHTML;
                  lastPart = tmp[1];

                  // let eleIdx = eleList.length;
                  // let tmpUrl = new URL(url);
                  // let fileName = tmpUrl.pathname.split("/").pop();
                  // let audio = new Audio();
                  // audio.src = url;
                  // audio.id = "audio" + eleIdx;
                  // let id = new Date().getTime();
                  // eleList.push({
                  //   type: "audio",
                  //   val: url,
                  //   fileName: fileName,
                  //   fileIcon: this.getFileIcon(fileName),
                  //   id: id,
                  // });
                  // audio.muted = true;
                  // audio.play().then(() => {
                  //   audio.pause();
                  // });
                  // audio.muted = false;
                  // audio.addEventListener("loadedmetadata", () => {
                  //   console.log("audio duration==", audio.duration);
                  //   this.eleList.forEach((ele, idx) => {
                  //     if (ele.id == id) {
                  //       this.eleList.splice(idx, 1, {
                  //         type: "audio",
                  //         val: url,
                  //         fileName: fileName,
                  //         fileIcon: this.getFileIcon(fileName),
                  //         duration: audio.duration * 1000,
                  //       });
                  //     }
                  //   });
                  // });
                  // this.audioList.push(audio);
                } else {
                  // let tmpUrl = new URL(url);
                  // const fileName = tmpUrl.pathname.split("/").pop();
                  // eleList.push({
                  //   type: "file",
                  //   val: url,
                  //   fileName: fileName,
                  //   fileIcon: this.getFileIcon(fileName),
                  // });
                  let tmpUrl = new URL(url);
                  let fileName = tmpUrl.pathname.split("/").pop();
                  let fileElement = this.getContentEditorFileItem(url, "file", {
                    file: {
                      name: fileName
                    }
                  });
                  newText += tmp[0] + fileElement.outerHTML;
                  lastPart = tmp[1];
                }
              }
            }
            val.newSpeechText = newText + lastPart;
            return val;
          });
          this.list.splice(this.list.length, 0, ...list);
          resolve();
        } else {
          resolve([]);
        }
      });
    }
  },
  created() {
    if (localStorage.getItem("typeList")) {
      this.typeList = JSON.parse(localStorage.getItem("typeList"));
    }
    this.qryHuashuList();
  },
  async mounted() {}
};